import { render, staticRenderFns } from "./chunai_hxca.vue?vue&type=template&id=fcdb0594&scoped=true"
import script from "./chunai_hxca.vue?vue&type=script&lang=js"
export * from "./chunai_hxca.vue?vue&type=script&lang=js"
import style0 from "./chunai_hxca.vue?vue&type=style&index=0&id=fcdb0594&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcdb0594",
  null
  
)

export default component.exports